import i18next from "i18next";

export default {
  inject: {
    showCheckboxesView: {
      default: () => {
        return () => false;
      }
    }
  },
  props: {
    isFilter: {
      type: Boolean,
      default: false
    },
    value: {
      type: [Object, String, Array, Boolean, Number],
      default: () => null
    },
    tooltip: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: () => i18next.t("common:all.filter.label", "All")
    },
    items: {
      type: Array,
      default: () => []
    },
    tooltipText: {
      type: String,
      default: () =>
        i18next.t(
          "common:filters.search.tooltip.FilterWithTyping",
          "Please start typing a name (min 3 characters)",
          "Tooltip for filters, when user should start typing the name"
        )
    },
    ignoreCheckboxesView: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: true
    },
    menuProps: {
      type: Object,
      default: null
    }
  },
  directives: {
    showFade: {
      bind(el, { value }) {
        if (!value.isFilter) return;
        var parent =
          el.querySelector(".v-select__selections") ||
          el.querySelector(".v-text-field__slot");
        if (!parent) return;

        var gradient = document.createElement("div");
        gradient.classList.add("gradient-clip");
        if (parent) parent.appendChild(gradient);
      }
    }
  },
  data() {
    return {
      selectMixinClass: "entsys--input-box"
    };
  },
  created() {
    if (this.menuProps && this.menuProperties)
      Object.assign(this.menuProperties, this.menuProps);
    if (!this.isFilter) this.selectMixinClass = "";
  },
  watch: {
    value(newVal) {
      // Sometimes this.$el isn't even rendered yet
      if (!this.$el.querySelector) return;
      // First two are not using inputVisibility or focused
      if (this.$vnode.componentOptions.tag == "AppGenericTextField") return;
      if (this.isComboboxComponent) return;
      if (this.isFilter || this.inputHideFeature) {
        if (!this.$el.querySelector("input")) return; // no input, then nothing can be done
        if (!this.multiple) {
          this.$el.querySelector("input").dispatchEvent(new Event("blur"));
        }

        let evt = { target: null };

        let target = this.$el.querySelector(".v-select__selections input");

        if (target) {
          evt.target = target;
          this._showOrHide(newVal, evt);
        }
      }
    }
  },
  computed: {
    nudgeBottom() {
      return this.isFilter ? 48 : 56;
    }
  },
  methods: {
    focused(evt) {
      if (this.isComboboxComponent) return;
      if (this.isFilter) {
        evt.target.style.opacity = 1;
      } else if (this.inputHideFeature) {
        evt.target.style.opacity = 1;
        evt.target.style.position = "revert";
      }
    },
    inputVisibility(evt, eventName = null) {
      // Sometimes this.$el isn't even rendered yet
      if (!this.$el.querySelector) return;
      if (this.isComboboxComponent) return;
      if (this.isFilter || this.inputHideFeature) {
        if (evt?.type === "blur") {
          if (this.value) {
            evt.target.style.opacity = 0;
          }
        } else if (evt?.type === "focus") {
          evt.target.style.opacity = 1;
        }

        if (!evt) {
          let target = this.$el.querySelector(".v-select__selections input");
          evt = {
            target: target
          };
        }
        let value = this.value;

        if (eventName == "change") {
          // @change only returns the new value
          value = evt;
          evt = {
            target: this.$el.querySelector(".v-select__selections input")
          };
        }
        this._showOrHide(value, evt);
      }
    },
    /**
     * Vuetify v-autocomplete when in single select the selected value is given in input element
     * But we have custom logic that makes input dissapear so this function exists to
     * ensure single select's won't have inputs dissapear
     * @param {*} evt
     * @returns boolean
     */
    _doNotHideInput(evt) {
      if (this.multiple) return false;
      return evt.target
        .closest(".v-select")
        ?.querySelector(".v-list-item__content")
        ? false
        : true;
    },
    _showOrHide(value, evt) {
      if (!evt || !evt.target) return;

      if (this._doNotHideInput(evt)) {
        return;
      }
      if (value == null || value.length == 0 || value == false || !value) {
        evt.target.style.opacity = 1;
        if (this.inputHideFeature) evt.target.style.position = "revert";
      } else {
        evt.target.style.opacity = 0;
        if (this.inputHideFeature) evt.target.style.position = "absolute";
      }
    }
  }
};
